export default function CsharpNumericTypes() {
  return (
    <h2>Csharp Numeric Types</h2>
  );
}
